import { Card, Divider } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ReactTimeAgo from "react-time-ago";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./Home.module.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import Button from "../../Subcomponents/Button";
import AllotmentBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import AllotmentprofileIcon from "../../Assets/Images/Common/AllotmentProfile.svg";
import AllotmentCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import AllotmentInfoIcon from "../../Assets/Images/Common/info-circle.svg";
import CancelUnit from "../../Modals/CancelUnit.js/CancelUnit";
import AllotmentDetails from "../AllotmentDetails/AllotmentDetails";
import { Tooltip } from "react-tooltip";
import { getAgreementForm, getSlotBooking, getStampDetails } from "../../Services/Agreement";
import { errorTost } from "../../Services/Toast";
import { supabase } from "../../supabaseClient";
import PreviewSlotBooking from "../../Modals/PreviewSlotBooking/PreviewSlotBooking";
import PreviewAgreementConfirm from "../../Modals/PreviewAgreementConfirm/PreviewAgreementConfirm";
import UnitCost from "../../Modals/UnitCost/UnitCost";
import { InfoOutlined } from "@mui/icons-material";
import Crm2PortalAppointment from "../Crm2Appointment/Crm2PortalAppointment";

const Agreement = ({ allotment, slotBookMode }) => {
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const [allotmentDetails, setAllotmentDetails] = useState({});
	const [openCancelUnitModal, setOpenCancelUnitModal] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [view, setView] = useState(false);
	const [slotView, setSlotView] = useState(false);
	const [stampDetails, setStampDetails] = useState([]);
	const [slotBooking, setSlotBooking] = useState([]);
	const [agreementForm, setAgreementForm] = useState([]);
	const [showUnitCost, setShowUnitCost] = useState(false);

	useEffect(() => {
		let insertStampListener = supabase
			.from(`StampDetails`)
			.on("INSERT", (handleRecordUpdated) => {
				console.log(handleRecordUpdated);
				if (handleRecordUpdated.new.bookingId === allotment?.allotmentPaymentId) {
					setStampDetails([handleRecordUpdated.new]);
				}
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		let updateStampListener = supabase
			.from(`StampDetails:bookingId=eq.${allotment?.allotmentPaymentId}`)
			.on("UPDATE", (handleRecordUpdated) => {
				console.log(handleRecordUpdated);
				setStampDetails([handleRecordUpdated.new]);
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		let insertSlotBookingListener = supabase
			.from(`SlotBookings`)
			.on("INSERT", (handleRecordUpdated) => {
				console.log(handleRecordUpdated);
				if (handleRecordUpdated.new.bookingId === allotment?.allotmentPaymentId) {
					setSlotBooking([handleRecordUpdated.new]);
				}
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		let updateSlotBookingListener = supabase
			.from(`SlotBookings:bookingId=eq.${allotment?.allotmentPaymentId}`)
			.on("UPDATE", (handleRecordUpdated) => {
				console.log(handleRecordUpdated);
				setSlotBooking([handleRecordUpdated.new]);
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});

		let insertAgreementFormListener = supabase
			.from(`AgreementForm`)
			.on("INSERT", (handleRecordUpdated) => {
				console.log(handleRecordUpdated);
				if (handleRecordUpdated.new.allotmentPaymentId === allotment?.allotmentPaymentId) {
					setAgreementForm([handleRecordUpdated.new]);
				}
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		let updateAgreementFormListener = supabase
			.from(`AgreementForm:allotmentPaymentId=eq.${allotment?.allotmentPaymentId}`)
			.on("UPDATE", (handleRecordUpdated) => {
				console.log(handleRecordUpdated);
				setAgreementForm([handleRecordUpdated.new]);
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		return () => {
			if (insertStampListener) {
				supabase.removeSubscription(insertStampListener);
				insertStampListener = null;
			}
			if (updateStampListener) {
				supabase.removeSubscription(updateStampListener);
				updateStampListener = null;
			}
			if (insertSlotBookingListener) {
				supabase.removeSubscription(insertSlotBookingListener);
				insertSlotBookingListener = null;
			}
			if (updateSlotBookingListener) {
				supabase.removeSubscription(updateSlotBookingListener);
				updateSlotBookingListener = null;
			}
			if (insertAgreementFormListener) {
				supabase.removeSubscription(insertAgreementFormListener);
				insertAgreementFormListener = null;
			}
			if (updateAgreementFormListener) {
				supabase.removeSubscription(updateAgreementFormListener);
				updateAgreementFormListener = null;
			}
		};
	}, []);

	useEffect(() => {
		getSlotBooking(allotment?.allotmentPaymentId)
			.then((slotResp) => {
				setSlotBooking(slotResp.data);
			})
			.catch((err) => {
				console.log(err);
				errorTost("Could not get Slot Booking! Please try again later");
			});
		getStampDetails(allotment?.allotmentPaymentId)
			.then(async (resp) => {
				setStampDetails(resp.data);
			})
			.catch((err) => {
				console.log(err);
				errorTost("Could not get Stamp Details! Please try again later");
			});
		getAgreementForm(allotment?.allotmentPaymentId)
			.then((agreememtResp) => {
				setAgreementForm(agreememtResp.data);
			})
			.catch((err) => {
				console.log(err);
				errorTost("Could not get Agreement Details! Please try again later");
			});
	}, []);

	function getAgreementDateInFormat(time) {
		const dateInFormat =
			new Date(time).toDateString() +
			" " +
			new Date(time).toLocaleTimeString([], {
				hour: "2-digit",
				minute: "2-digit",
			});
		// console.log(dateInFormat);
		if (dateInFormat !== "Invalid Date Invalid Date") return dateInFormat;
		else return time;
	}

	return (
		<>
			<Card className={cssClasses.allotmentEventWrap} style={{ borderRadius: "20px", boxShadow: "none" }}>
				<div className={cssClasses.allotmentCardHeader}>
					<div className={cssClasses.allotmentTokenNumWrap}>
						<div className={cssClasses.allotmentImg}>
							<img src={AllotmentBuildingIcon} alt="allotment" />
						</div>
						<div className={cssClasses.allotmentProjectDetail}>
							<div className={cssClasses.allotmentProjectDetailFirst}>
								<span>
									{allotment?.unitId && (
										<span>
											{allotment?.unitId.wingId.displayName
												? allotment?.unitId.wingId.displayName
												: allotment?.unitId.wingId.wingName}{" "}
											- {allotment?.unitId.unitNo}
										</span>
									)}
									{allotment?.inventoryMergedId &&
										((allotment?.inventoryMergedId.unit1Id.wingId.wingId ===
											allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
												<span>
													{allotment?.inventoryMergedId.unit1Id.wingId.displayName
														? allotment?.inventoryMergedId.unit1Id.wingId.displayName
														: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
													- {allotment?.inventoryMergedId.unit1Id.unitNo} & {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
												</span>
											)) ||
											(allotment?.inventoryMergedId.unit1Id.wingId.wingId !==
												allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
													<span>
														{allotment?.inventoryMergedId.unit1Id.wingId.displayName
															? allotment?.inventoryMergedId.unit1Id.wingId.displayName
															: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
														{allotment?.inventoryMergedId.unit2Id.wingId.displayName
															? allotment?.inventoryMergedId.unit2Id.wingId.displayName
															: allotment?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
													</span>
												)))}
								</span>
								{allotment.paymentId?.eventTokenId?.tokenId.isPreselect && (
									<span>
										<LeadStatusChip
											label={"Preselect"}
											style={{
												color: "#FF7B01",
												border: "1px solid #FFC997",
												borderRadius: "0px",
											}}
										></LeadStatusChip>
									</span>
								)}
							</div>
							<div className={cssClasses.allotmentProjectName}>
								{allotment?.unitId && <span>{allotment?.unitId.projectId.projectName}</span>}
								{allotment?.inventoryMergedId && <span>{allotment?.inventoryMergedId.projectId.projectName}</span>}
							</div>
						</div>
					</div>
					<div className={cssClasses.allotmenttimeActionSection}>
						<div className={cssClasses.allotmentTokenLastUpdate}>
							<ReactTimeAgo style={{ fontSize: "1.2rem" }} date={allotment?.last_updated_at ?? allotment?.created_at} locale="en-US" />
						</div>
						<div className={cssClasses.tokenActions}>
							<ThreeDotsMenu
								list={allotment.menuOpt}
								selectedValue={(e) => {
									if (e === "View Details") {
										setAllotmentDetails(allotment);
										setShowDetails(true);
										// setScheduleSiteVisitModal(true);
									} else if (e === "Cancel Unit") {
										setOpenCancelUnitModal(true);
										setAllotmentDetails(allotment);
									}
								}}
							/>
						</div>
					</div>
				</div>
				<div style={{ width: "100%" }}>
					<div className={cssClasses.tokenStatus}>
						{agreementForm?.length > 0 && (agreementForm[0]?.agreementStatus?.agreement_done_status || agreementForm[0]?.agreementStatus?.agreement_done_status === "true") && (
							<LeadStatusChip
										label={"Agreement Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#027A48",
											backgroundColor: "#ECFDF3",
										}}
							></LeadStatusChip>)
						}
						{allotment.status === "Payment Complete" || allotment.status === "Agreement Done" ? (
							<>
								{/* ? if 5,00,000 amount is paid; check for SDR amount */}
								{allotment.unitCost?.sdr - allotment.paidAmt?.sdr > 0 ? (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								) : (
									<LeadStatusChip
										label={"SDR Complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#027A48",
											backgroundColor: "#ECFDF3",
										}}
									></LeadStatusChip>
								)}
								{!allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "Cancelled" ||
									allotment.status === "Change Requested" ||
									allotment.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
							</>
						) : (
							<>
								{allotment.status === "Partial Payment Done" && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "Payment Pending" && (
									<LeadStatusChip
										label={"Payment Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B42318",
											backgroundColor: "#FEF3F2",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "expired" && (
									<LeadStatusChip
										label={"Expired"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "On Hold" && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#3538CD",
											backgroundColor: "#EEF4FF",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "Released" ||
									allotment.status === "Refund Processed" ||
									allotment.status === "Refund Initiated") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "rgb(180, 35, 24)",
												backgroundColor: "rgb(254, 243, 242)",
											}}
										></LeadStatusChip>
									)}
								{allotment.status === "Partial Payment Done" && !allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "cancelled" ||
									allotment.status === "Cancelled" ||
									allotment.status === "Cancellation Rejected" ||
									allotment.status === "Change Requested" ||
									allotment.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
							</>
						)}
						{allotment?.leadId?.LeadsReferral.length > 0 && allotment?.leadId?.LeadsReferral[0]?.id &&
							<LeadStatusChip
								label="VJOP"
								style={{
									color: "rgb(180, 35, 24)",
									backgroundColor: "rgb(254, 243, 242)",
								}}
							></LeadStatusChip>
						}
					</div>
				</div>
				<div className={cssClasses.allotmentCpDetails}>
					<div className={cssClasses.allotmentPrice}>
						<div className={cssClasses.allotmentCpImg}>
							<img src={AllotmentprofileIcon} alt="profile" />
						</div>
						<div>
							<div className={cssClasses.allotmentCpText}>VJ Sales Manager : </div>
							<div>{loggedInUser?.userId?.name ?? "NA"}</div>
						</div>
					</div>
					<Divider orientation="vertical" variant="middle" flexItem />
					<div className={cssClasses.allotmentPrice}>
						<div className={cssClasses.allotmentCpImg}>
							<img src={AllotmentprofileIcon} alt="profile" />
						</div>
						<div>
							<div className={cssClasses.allotmentCpText}>CP : </div>
							<div>{loggedInUser?.cpId?.billingName ?? "NA"}</div>
						</div>
					</div>
					<Divider orientation="vertical" variant="middle" flexItem />
					<div className={cssClasses.allotmentPrice}>
						<div className={cssClasses.allotmentCpImg}>
							<img src={AllotmentprofileIcon} alt="profile" />
						</div>
						<div>
							<div className={cssClasses.allotmentCpText}>FOS : </div>
							<div>{loggedInUser?.fosId?.name ?? "NA"}</div>
						</div>
					</div>
				</div>
				<div className={cssClasses.allotmentCardData}>
					<div className={cssClasses.allotmentCardDetails}>
						<div className={cssClasses.allotmentEventData}>
							<div className={cssClasses.allotmentTokenData}>
								<span className={cssClasses.AllotmentEventName}>{allotment.paymentId?.eventTokenId?.eventId?.title}</span>
							</div>
							<div className={cssClasses.allotmentUnitDetails}>
								{allotment?.unitId?.inventoryTypeId?.type &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Inventory Type") ? (
									<span>{allotment?.unitId?.inventoryTypeId?.type} • </span>
								) : (
									""
								)}
								{allotment?.unitId?.displayUnitType &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Display Unit Type") ? (
									<span>{allotment?.unitId?.displayUnitType} • </span>
								) : (
									""
								)}
								{/* } */}
								{allotment.inventoryMergedId && (
									<>
										{/* {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type === allotment.inventoryMergedId.unit2Id.inventoryTypeId.type &&
                                                    <span>{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type}</span>
                                                }
                                                {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type !== allotment.inventoryMergedId.unit2Id.inventoryTypeId.type && */}
										<span>
											{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type} -{" "}
											{allotment.inventoryMergedId.unit2Id.inventoryTypeId.type}
										</span>
										{/* } */}
									</>
								)}

								{allotment.unitId && <span>{allotment.unitId.floorNo}</span>}
								<span>{" • "}</span>
								{allotment.unitId && (
									// <span>Area {allotment.unitId.chargeableArea} sq.ft</span>
									<span>Area {allotment.unitId.saleableArea} sq.ft</span>
								)}
								{allotment.inventoryMergedId && (
									<>
										{allotment.inventoryMergedId.unit1Id.floorNo === allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>{allotment.inventoryMergedId.unit1Id.floorNo}</span>
										)}
										{allotment.inventoryMergedId.unit1Id.floorNo !== allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>
												{allotment.inventoryMergedId.unit1Id.floorNo} - {allotment.inventoryMergedId.unit2Id.floorNo}
											</span>
										)}
									</>
								)}
								{allotment.inventoryMergedId && (
									<>
										<span>
											Area {allotment.inventoryMergedId.unit1Id.saleableArea} +{" "}
											{allotment.inventoryMergedId.unit2Id.saleableArea} sq.ft
										</span>
									</>
								)}
							</div>
						</div>
						<div className={cssClasses.allotmentDateContent}>
							<div className={cssClasses.allotmentDateData}>
								<img src={AllotmentCalenderIcon} alt="Calender-check" />
								Alloted On:{" "}
							</div>
							<div className={cssClasses.allotmentDate}>
								{new Date(allotment.created_at).toDateString()},{" "}
								{new Date(allotment.created_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</div>
						</div>
					</div>
					<div className={cssClasses.allotmentPriceBreakDown}>
						{/* CRM 2.0 bookings show the registration appointment section below instead */}
						{!allotment?.isCrm2 && (
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								Slot Booked:
								<img data-tooltip-id="slot" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="slot" content="Slot Booked" />
							</div>
							<div className={cssClasses.agreementStatus}>
								{slotBooking?.length > 0 ? (
									<>
										<span className={cssClasses.agreementYesStatus}>YES</span>
										<span className={cssClasses.agreementDate}>
											{new Date(slotBooking[slotBooking.length - 1]?.appointmentTime).toDateString()}
										</span>
									</>
								) : (
									<span className={cssClasses.agreementNoStatus}>No</span>
								)}
							</div>
						</div>
						)}
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								Stamp :
								<img data-tooltip-id="stamp" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="stamp" content="Stamp" />
							</div>
							<div className={cssClasses.agreementStatus}>
								{stampDetails?.length > 0 ? (
									<>
										<span className={cssClasses.agreementYesStatus}>YES</span>
										<span className={cssClasses.agreementDate}>
											{new Date(stampDetails[stampDetails?.length - 1]?.last_updated_at).toDateString()}
										</span>
									</>
								) : (
									<span className={cssClasses.agreementNoStatus}>No</span>
								)}
							</div>
						</div>
						{allotment?.isCrm2 ? null : agreementForm?.length > 0 && agreementForm[0]?.agreementSuccess?.appointment_link === "" ? (
							<div className={cssClasses.agreementSlotBookingText} style={{ width: "100%" }}>
								Book Your Slot
							</div>
						) : (
							slotBooking?.length > 0 && (
								<div className={cssClasses.agreementSlotBookingText} style={{ width: "100%" }}>
									<div className={cssClasses.riderMainContent}>
										<div className={cssClasses.riderContent}>
											<div>Rider Details</div>
											{slotBooking[0]?.riderName ? (
												<div className={cssClasses.riderContentDetails}>{slotBooking[0]?.riderName}</div>
											) : (
												<div className={cssClasses.riderNoContent}>(No Rider Name)</div>
											)}
										</div>
										{slotBooking[0]?.riderContact ? (
											<div className={cssClasses.riderContentDetails}>{slotBooking[0]?.riderContact}</div>
										) : (
											<div className={cssClasses.riderNoContent}>(No Rider Contact)</div>
										)}
										{slotBooking[0]?.riderEmail ? (
											<div className={cssClasses.riderContentDetails}>{slotBooking[0]?.riderEmail}</div>
										) : (
											<div className={cssClasses.riderNoContent}>(No Rider Email)</div>
										)}
									</div>
								</div>
							)
						)}
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								Agreement Done :
								<img data-tooltip-id="agreement" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="agreement" content="Agreement Done" />
							</div>
							<div className={cssClasses.agreementStatus}>
								{agreementForm?.length > 0 && (agreementForm[0]?.agreementStatus?.agreement_done_status || agreementForm[0]?.agreementStatus?.agreement_done_status === "true") ? (
									<>
										<span className={cssClasses.agreementYesStatus}>YES</span>
										<span className={cssClasses.agreementDate}>
											{agreementForm?.length > 0 &&
												agreementForm[0]?.agreementSuccess &&
												getAgreementDateInFormat(agreementForm[0]?.agreementStatus?.agreement_date)}
										</span>{" "}
									</>
								) : (
									<span className={cssClasses.agreementNoStatus}>No</span>
								)}
							</div>
						</div>
					</div>
				</div>
				{allotment?.isCrm2 && <Crm2PortalAppointment allotmentPaymentId={allotment?.allotmentPaymentId} />}
				<div className={cssClasses.allotmentActionBtnWrap}>
					<div className={cssClasses.allotmentBtnView}>
						<Button
							btnName={"View Unit Cost"}
							clicked={() => setShowUnitCost(true)}
							style={{
								color: "#344054",
								backgroundColor: "#FFFFFF",
								fontSize: "1.4rem",
								lineHeight: "2rem",
								fontFamily: "Inter-Medium !important",
							}}
						></Button>
					</div>
					{allotment?.CRM[0]?.isPreviewAgreementEnable && 
					(agreementForm?.length > 0 && !(agreementForm[0]?.agreementStatus?.agreement_done_status || agreementForm[0]?.agreementStatus?.agreement_done_status === "true")) && (
						<Button
							btnName={
								allotment?.CRM[0]?.isSlotBookingOtpVerified
									? "Preview Agreement"
									: "Preview Agreement & Confirm"
							}
							clicked={() => {
								setView(true);
							}}
							style={{
								color: "#fff",
								backgroundColor: "rgb(21, 112, 239)",
								fontSize: "1.4rem",
								lineHeight: "2rem",
								fontFamily: "Inter-Medium !important",
							}}
						/>
					)}
					{slotBooking?.length === 0 && slotBookMode && !allotment?.isCrm2 && (
						<div className={cssClasses.agreementSlotBookingBtn} style={{ width: "100%" }}>
							<div className={cssClasses.allotmentActionBtnWrap}>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Button
										disable={allotment?.CRM[0]?.skipCreateDraft}
										btnName={"Book Slot"}
										clicked={() => {
											setSlotView(true);
										}}
										style={{
											color: "#fff",
											backgroundColor: "rgb(21, 112, 239)",
											fontSize: "1.4rem",
											lineHeight: "2rem",
											fontFamily: "Inter-Medium !important",
										}}
									/>
									{allotment?.CRM[0]?.skipCreateDraft && (
										<>
											<InfoOutlined
												data-tooltip-id="slotbtn"
												style={{
													width: "2rem",
													height: "2rem",
													color: "rgba(179, 35, 24, 1)",
												}}
											/>
											<Tooltip id="slotbtn" content="Slot Booking is disabled, contact your CRM" />
										</>
									)}
								</div>
							</div>
							{/* <iframe src={agreementForm[0]?.agreementSuccess?.appointment_link} frameBorder="0" title={`coasting_document_B`} /> */}
						</div>
					)}
				</div>
				{view && (
					<PreviewAgreementConfirm
						open={view}
						handleClose={() => {
							setView(false);
						}}
						allotment={allotment}
					/>
				)}
				{slotView && (
					<PreviewSlotBooking
						open={slotView}
						handleClose={() => {
							setSlotView(false);
						}}
						url={agreementForm[0]?.agreementSuccess?.appointment_link}
					/>
				)}
			</Card>
			{showDetails && (
				<AllotmentDetails
					open={showDetails}
					handleClose={() => {
						setAllotmentDetails({});
						setShowDetails(false);
					}}
					data={allotmentDetails}
				/>
			)}
			{openCancelUnitModal && (
				<CancelUnit
					open={openCancelUnitModal}
					handleClose={() => {
						setOpenCancelUnitModal(false);
					}}
					allotmentDetails={allotmentDetails}
				/>
			)}
			{showUnitCost && (
				<UnitCost
					allotment={allotment}
					open={showUnitCost}
					handleClose={() => {
						setShowUnitCost(false);
					}}
				/>
			)}
		</>
	);
};

export default Agreement;
